import { render, staticRenderFns } from "./RetakeExamSecondTime.vue?vue&type=template&id=ed4cc5b4&"
import script from "./RetakeExamSecondTime.vue?vue&type=script&lang=js&"
export * from "./RetakeExamSecondTime.vue?vue&type=script&lang=js&"
import style0 from "./RetakeExamSecondTime.vue?vue&type=style&index=0&id=ed4cc5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports